import type { CommonContent } from '../types/CommonContent';
import type { ImageElement, PlainTextElement } from '../types/SiteContentElement';

export function createCommonContentPlaceholder(): CommonContent {
    const empty: PlainTextElement = { kind: 'plainText' as const, key: '', content: '' };
    const emptyImage: ImageElement = { kind: 'image' as const, key: '', imageUrl: '' };
    return {
        geographic: {
            countrySelectLabel: empty,
            countrySelectPlaceholder: empty,
            regionSelectLabel: empty,
            regionSelectPlaceholder: empty,
            subnationalRegionSelectLabel: empty,
            subnationalRegionSelectPlaceholder: empty,
        },
        ResourceLibrary: {
            itemClasses: {
                NewProductIntroductionItem: {
                    defaultPageTitleBackgroundImage: emptyImage,
                    quickFactsSectionLabel: empty,
                    featuresSectionLabel: empty,
                    customerValueSectionLabel: empty,
                    targetApplicationsSectionLabel: empty,
                    marketAdvantagesSectionLabel: empty,
                    productBriefButtonLabel: empty,
                    similarProductsButtonLabel: empty,
                    contactUsButtonLabel: empty,
                    contactLocalSalesStatement: empty,
                },
                SitePageItem: {
                    common: {
                        tabs: {
                            Overview: {
                                title: empty,
                            },
                            Datasheets: {
                                title: empty,
                            },
                            Resources: {
                                title: empty,
                            },
                        },
                    },
                    templates: {
                        ApplicationArticle: {
                            defaultPageTitleBackgroundImage: emptyImage,
                            tabs: {
                                Overview: {
                                    title: empty,
                                },
                                Datasheets: {
                                    title: empty,
                                },
                                Resources: {
                                    title: empty,
                                },
                            },
                        },
                        Generic: {
                            defaultPageTitleBackgroundImage: emptyImage,
                        },
                    },
                },
            },
            buttonLabels: {
                openItem: {
                    article: empty,
                    asset: empty,
                    internalLink: empty,
                    news: empty,
                },
            },
            categories: {
                applications: empty,
                brands: empty,
                products: empty,
                resourceType: empty,
            },
            dateLabels: {
                expiration: empty,
                lastModification: empty,
                publication: empty,
                validFrom: empty,
            },
            filtersLabel: empty,
            missingSearchTermsLabel: empty,
            noResultsFound: empty,
            numberOfResults: empty,
            reset: empty,
            searchInputPlaceholder: empty,
            sortByLatestFirst: empty,
            sortByMostRelevantFirst: empty,
            sortByOldestFirst: empty,
            sortOptionLabel: empty,
        },
        search: {
            clearGenericButtonLabel: empty,
            globalSearchInputIconAltText: empty,
            globalSearchInputPlaceholder: empty,
            globalSearchInputTooltip: empty,
            paginationRange: empty,
            rowsPerPageLabel: empty,
            searchButtonGenericLabel: empty,
            searchingFor: empty,
        },
        misc: {
            loadingGeneric: empty,
            loadingYourContent: {
                kind: 'plainText' as const,
                key: '',
                content: 'Loading your content',
            },
            readMoreButtonLabel: empty,
            readLessButtonLabel: empty,
        },
        tabs: {
            Datasheets: {
                title: empty,
            },
            Overview: {
                title: empty,
            },
            Products: {
                title: empty,
            },
            Resources: {
                title: empty,
            },
            SimulationTools: {
                title: empty,
            },
        },
    };
}
